export default __webpack_public_path__ + "static/media/hoitokeskustelu-lightblue.5995ced8.svg";